'use strict';

var BrushSelectionFilterFactory = function BrushSelectionFilterFactory() {
  function BrushSelectionFilter(filterType, filterParameters) {
    this.filterType = filterType;
    this.filterArguments = [filterParameters];
  }
  BrushSelectionFilter.prototype.isEmpty = function () {
    return this.filterArguments[0].length === 0;
  };
  BrushSelectionFilter.prototype.getArguments = function () {
    return this.filterArguments[0];
  };
  return BrushSelectionFilter;
};
BrushSelectionFilterFactory.$inject = [];
module.exports = BrushSelectionFilterFactory;